import { BoxB2BSubscribedProgramsEntity } from "@modules/boxB2BProgram/entities/boxB2BSubscribedProgramsEntity"
import { useServicesContext } from "@modules/core/services/services.context"
import { useSuspenseInfiniteQuery } from "@tanstack/react-query"
import { useMemo } from "react"

export const useBoxSubscribedB2BPrograms = () => {
  const { boxB2BProgramApi } = useServicesContext()

  const { data, fetchNextPage, isLoading, isFetching, hasNextPage, isFetchingNextPage } = useSuspenseInfiniteQuery({
    queryKey: ["boxB2BPrograms"],
    queryFn: async ({ pageParam }) => {
      const result = await boxB2BProgramApi.getBoxSubscribedB2BPrograms(pageParam, 50)
      return result
    },
    initialPageParam: 0,
    getNextPageParam: (lastPage) => {
      if (lastPage.page >= lastPage.totalPages - 1) {
        return null
      }
      return lastPage.page + 1
    },
  })

  const itemList = useMemo(
    () =>
      data.pages.flatMap((page) => page.content).map((content) => BoxB2BSubscribedProgramsEntity.fromDto(content)) ??
      [],
    [data],
  )

  return {
    data: { ...data, content: itemList, totalElements: data.pages[0]?.totalSize ?? 0 },
    isLoading,
    isFetching,
    fetchNextPage,
    hasNextPage,
    isFetchingNextPage,
  }
}
